import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { IlllstrationBottomSkillReviewCard, IlllstrationTopSkillReviewCard } from '@lyearn/icons';
import { LinearGradient, Stack, StatusPill } from '@lyearn/ui';
import * as BaseCard from '@/modules/content/components/ContentCard/BaseCard';
import DefaultCard from '@/modules/content/components/ContentCard/DefaultCard';

import { SKILL_REVIEW_ACTION_CLASSES } from '../styles';
import { SkillReviewCardProps } from '../types';
import useAdapt from '../useAdapt';

const SkillReviewCardDefault: React.FC<SkillReviewCardProps> = (props) => {
  const { className, content } = props;
  const { t } = useTranslation(['Skills']);
  const adaptedContent = useAdapt(content);
  const { isMobile } = useScreen();

  return (
    <DefaultCard className={className} content={adaptedContent}>
      <LinearGradient
        className="absolute inset-0 rounded-16"
        css={'linear-gradient(141.17deg, #000000 0%, #262626 93.83%)'}>
        <IlllstrationTopSkillReviewCard
          className="opacity-30 absolute"
          fillColorToken="icon-white"
        />
        <IlllstrationBottomSkillReviewCard
          className="opacity-20 absolute bottom-0"
          fillColorToken="icon-white"
        />
      </LinearGradient>
      <Stack
        alignItems="start"
        className="absolute inset-0 flex-1 rounded-16 p-20 pt-16"
        direction="col">
        {adaptedContent.isOverDue ? (
          <StatusPill
            appearance="inverse"
            className="z-10 mb-18"
            label={t('Common:ContentCards.Overdue')}
            variant="light"
          />
        ) : null}
        <BaseCard.Name
          className="capitalize"
          color="text-text-white"
          variant={isMobile ? 'display-xs' : 'display-l'}
          {...(isMobile ? { numberOfLines: 3 } : { numberOfLines: 2 })}
        />
        <BaseCard.Description
          className="uppercase opacity-60"
          color="text-text-white"
          numberOfLines={2}
          variant={isMobile ? 'display-xs' : 'display-l'}
        />
        <BaseCard.Progress className="mt-32" color="inverse" />
        <BaseCard.PrimaryAction classes={SKILL_REVIEW_ACTION_CLASSES}>
          {adaptedContent.progress && adaptedContent.progress > 0
            ? t('Skills:Review.ContinueReviewing')
            : t('Skills:Review.StartReviewing')}
        </BaseCard.PrimaryAction>
      </Stack>
    </DefaultCard>
  );
};

export default SkillReviewCardDefault;
